import React, { useEffect, useState } from "react";
import logo from "../assets/logo.svg";
import logoSrmd from "../assets/titlecopy.png";
import ashramImageTwo from "../assets/Frame 1000003029 (1).svg";
import ashramImageThree from "../assets/Frame 1000003030 (1).svg";
import meal from "../assets/Frame1000002799.svg";
import ashramTour from "../assets/Group 1445.svg";
import clock from "../assets/material-symbols_history.svg";
import people from "../assets/Vector.svg";
import GroupClock from "../assets/Group.svg";
import navigation from "../assets/ic_baseline-place.svg";
import Gif from "../assets/Animation - 1728624754225 (1).gif";
import ashramImage from "../assets/Frame1000003028.svg";
import ashramImageTwoold from "../assets/Frame1000003029.svg";
import ashramImageThreeold from "../assets/Frame1000003030.svg";
import LanguageToggle from "../components/LanguageToggle";
import { useLanguage } from "../../src/context/LanguageContext";
import translations from "../components/translations";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { load } from "@cashfreepayments/cashfree-js";
import { useNavigate } from "react-router-dom";


const preloadImages = (imageUrls) => {
  imageUrls?.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

const DashBoard = () => {
  const { passId } = useParams();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const t = translations[language];
  const [isMealsOpen, setIsMealsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slideDirection] = useState("");
  const [userData, setUserData] = useState([]);
  const [BuggyData, setBuggyData] = useState([]);
  const [MealsData, setMealsData] = useState([]);
  const [touchPosition, setTouchPosition] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isSecOpen, setSecIsOpen] = useState(false);
  const [isThirdOpen, setThirdIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isTourLoading, setIsTourLoading] = useState(false);
  const [isTourSubmitLoading, setIsTourSubmitLoading] = useState(false);
  const [isFourLoading, setFourIsLoading] = useState(false);
  const [TourLoading, setTourLoading] = useState(false);
  const [TourEnable] = useState(true);
  const [isFiveLoading, setFiveIsLoading] = useState(false);
  const [isSecLoading, setSecIsLoading] = useState(false);
  const [isCancelLoading, setCancelIsLoading] = useState(false);
  const [TransactionHistoryData, setTransactionHistoryData] = useState([]);
  const [ScanningHistoryData, setScanningHistoryData] = useState([]);
  const [Time, setTime] = useState([]);
  const [TimeEnd, setTimeEnd] = useState([]);
  const [mealCounts, setMealCounts] = useState({
    breakfast: 0,
    lunch: 0,
    dinner: 0,
  });
  const [BookCounts, setBookCounts] = useState(0);
  const [BookCountShake, setBookCountShake] = useState(false);
  const [mealShows, setMealShows] = useState(null);
  // const [TourPopup, setTourPopup] = useState(null);
  const [TourSecPopup, setTourSecPopup] = useState(null);
  const [CancelTourSecPopup, setCancelTourSecPopup] = useState(null);
  const [TourList, setTourList] = useState(null);
  const [TourHistoryList, setTourHistoryList] = useState([]);
  const [TourHistoryListById, setTourHistoryListById] = useState({});
  const [LoginApi, setLoginApi] = useState(null);
  const [shake, setshake] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [mealshake, setMealshake] = useState({
    breakfast: false,
    lunch: false,
    dinner: false,
   });

  const getCategoryRate = (categoryName) => {
    const category = MealsData?.find(
      (meal) => meal?.categoryName === categoryName
    );
    return category ? category : null;
  };

  const getCategoryTime = (categoryId) => {
    const category = Time?.find((meal) => meal?.categoryId === categoryId);
    return category ? category : null;
  };

  const formatMealTimeHeader = (categoryName) => {
    const header =
      getCategoryTime(getCategoryRate(categoryName)?.categoryId)?.header ?? "";
    if (!header) return "";

    return header
      .replace(`${categoryName} (`, "")
      .replace(")", "")
      .replace(
        /(\d+):?(\d{0,2})?(am|pm)/g,
        (match, p1, p2, p3) =>
          `${p1.length === 1 ? p1 : p1.padStart(2, "0")}${
            p2 ? `:${p2}` : `.00`
          } ${p3}`
      )
      .replace(/(\d+)\.(\d{2})\.(\d{2})/g, "$1.$2")
      .replace("-", " - ");
  };

  const hasAnyMealAvailable =
    (mealShows?.Breakfast && getCategoryRate("Breakfast")?.categoryRate > 0) ||
    (mealShows?.Lunch && getCategoryRate("Lunch")?.categoryRate > 0) ||
    
    (mealShows?.Dinner && getCategoryRate("Dinner")?.categoryRate > 0) ;

  const hasAnyMealQtySelected = Object.values(mealCounts).some(
    (qty) => (qty ?? 0) > 0
  );

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [MaxBookCounts, setMaxBookCounts] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleSvgClick = () => {
    setIsMealsOpen(!isMealsOpen);
  };

  const handleViewAllClick = (route) => {
    navigate(`${route}/${userData[0]?.GroupId}`);
  };

  const handleMealDecrement = (meal) => {
    if (mealCounts[meal] > 0) {
      setMealCounts((prevCounts) => ({
        ...prevCounts,
        [meal]: Math.max((prevCounts[meal] ?? 0) - 1, 0),
      }));
    } else {
      setMealshake((prevShake) => ({ ...prevShake, [meal]: true }));
      setTimeout(() => {
        setMealshake((prevShake) => ({ ...prevShake, [meal]: false }));
      }, 500);
    }
  };

  const handleMealIncrement = (meal) => {
    const previousMealBookings = TransactionHistoryData?.filter(
      (transaction) => transaction?.categoryName?.toLowerCase() === meal
    );
    const totalMealBookings = previousMealBookings?.reduce(
      (total, transaction) => total + transaction?.quantity,
      0
    );
    if (
      mealCounts[meal] < userData?.length &&
      totalMealBookings + mealCounts[meal] < userData?.length
    ) {
      setMealCounts((prevCounts) => ({
        ...prevCounts,
        [meal]: (prevCounts[meal] ?? 0) + 1,
      }));
    } else {
      if (
        totalMealBookings > 0 &&
        totalMealBookings + mealCounts[meal] <= userData?.length
      ) {
        if (userData?.length - totalMealBookings === 0) {
          toast.error(
            `You have already Booked ${totalMealBookings} ${meal}.You Can not add more ${meal}`
          );
        }
        if (userData?.length - totalMealBookings > 0) {
          toast.error(
            `You have already Booked ${totalMealBookings} ${meal}.You Can Only add ${
              userData?.length - totalMealBookings
            } more ${meal}`
          );
        }
      }
      setMealshake((prevShake) => ({ ...prevShake, [meal]: true }));
      setTimeout(() => {
        setMealshake((prevShake) => ({ ...prevShake, [meal]: false }));
      }, 500);
    }
  };

  const handleIncrement = () => {
    if (count < userData?.length) {
      setCount(count + 1);
    } else {
      setshake(true);
      setTimeout(() => {
        setshake(false);
      }, 500);
    }
  };

  const subtotal = Object.keys(mealCounts).reduce((acc, mealKey) => {
    const price =
      {
        breakfast: getCategoryRate("Breakfast")?.categoryRate,
        lunch: getCategoryRate("Lunch")?.categoryRate,
        dinner: getCategoryRate("Dinner")?.categoryRate,
      }[mealKey] ?? 0;

    const qty = mealCounts?.[mealKey] ?? 0;
    return acc + qty * (price ?? 0);
  }, 0);

  const handleDecrement = () => {
    if (count > 0) {
      setCount(count - 1);
    } else {
      setshake(true);
      setTimeout(() => {
        setshake(false);
      }, 500);
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSecOpen = () => {
    setSecIsOpen(true);
  };

  const handleThirdOpen = () => {
    setThirdIsOpen(true);
    if (LoginApi) {
      EventsListsIs();
    }
  };

  const handleSecClose = () => {
    setSecIsOpen(false);
  };

  const handleThirdClose = () => {
    setThirdIsOpen(false);
  };

  const handleTouchStart = (event) => {
    setTouchPosition(event.touches[0].clientX);
  };

  const handleTouchEnd = (event) => {
    const currentPosition = event.changedTouches[0].clientX;
    const diff = currentPosition - touchPosition;
    if (diff > 50) {
      handlePrevious();
    } else if (diff < -50) {
      handleNext();
    }
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % userData?.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? userData?.length - 1 : prevIndex - 1
    );
  };

  const OnlineBook = async () => {
    const tourQuantities = TourHistoryList?.reduce((acc, tour) => {
      if (acc[tour.name]) {
        acc[tour.name] += tour.qty;
      } else {
        acc[tour.name] = tour.qty;
      }
      return acc;
    }, {});
    const tourTotalQuantities = TourHistoryList?.reduce((acc, tour) => {
      acc += tour?.qty;
      return acc;
    }, 0);
    const TourValue = tourQuantities[TourSecPopup?.name] || 0;
    if (MaxBookCounts >= tourTotalQuantities + BookCounts) {
      if (MaxBookCounts > tourTotalQuantities) {
        if (MaxBookCounts > TourValue) {
          if (TourValue + BookCounts <= MaxBookCounts) {
            try {
              setIsTourSubmitLoading(true);
              const payload = {
                fields: ["id", "name", "email", "group_id", "event_id"],
                values: [
                  {
                    event_id: TourSecPopup?.id,
                    name: userData[0]?.FullName,
                    group_id: userData[0]?.GroupId,
                    phone:
                      userData[0]?.CountryDialingCode?.toString()?.includes("+")
                        ? userData[0]?.CountryDialingCode
                        : "+" +
                          userData[0]?.CountryDialingCode +
                          userData[0]?.MobileNo,
                    email: "",
                    qty: BookCounts,
                  },
                ],
              };
              const response = await fetch(
                `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.registration`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    login: `${process.env.REACT_APP_ODOO_USERNAME}`,
                    password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
                    "api-key": LoginApi,
                  },
                  body: JSON.stringify(payload),
                }
              );
              const result = await response.json();
              if (result?.created_records) {
                toast.success("Tour Booked Successfully");
                TourFetchHistory();
                setTourSecPopup(null);
                setIsTourSubmitLoading(false);
                setBookCounts(0);
              } else {
                setIsTourSubmitLoading(false);
                console.log("error");
                toast.error(result?.error?.message);
              }
            } catch (error) {
              setIsTourSubmitLoading(false);
              console.log(error);
            }
          } else {
            toast.error(
              `You can only book for ${
                MaxBookCounts - TourValue
              } more people for this tour. Please reduce the number of people to proceed with the booking.`
            );
            return;
          }
        } else {
          toast.error(
            `It looks like you’ve already Booked "${TourSecPopup?.name}" for ${TourValue} people. To rebook, please cancel your current booking first.`
          );
          return;
        }
      } else {
        toast.error(
          `It looks like you’ve already Booked Tour for ${tourTotalQuantities} people. To rebook, please cancel your current booking first.`
        );
        return;
      }
    } else {
      if (MaxBookCounts - tourTotalQuantities === 0) {
        toast.error(
          `You can not  book  more people. To rebook, please cancel your current booking first.`
        );
        return;
      } else {
        toast.error(
          `You can only book for ${
            MaxBookCounts - tourTotalQuantities
          } more people. Please reduce the number of people to proceed with the booking.`
        );
        return;
      }
    }
  };

  const CancelBook = async (ID) => {
    try {
      setCancelIsLoading(ID);
      const payload = {
        fields: [
          "id",
          "name",
          "email",
          "phone",
          "qty",
          "event_id",
          "group_id",
          "state",
        ],
        values: {
          state: "cancel",
        },
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.registration&Id=${ID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            login: `${process.env.REACT_APP_ODOO_USERNAME}`,
            password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
            "api-key": LoginApi,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (!result?.error) {
        toast.success("Tour Cancelled Successfully");
        TourFetchHistory();
        setCancelIsLoading(false);
        handleCancelClose();
      } else {
        setCancelIsLoading(false);
        toast.error(result?.error?.message);
      }
    } catch (error) {
      setCancelIsLoading(false);
      console.log(error);
    }
  };

  const DateFunction = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const PayOnlineBuggy = async () => {
    setSecIsLoading(true);

    const payload = {
      items: [
        {
          startDate: DateFunction(),
          endDate: DateFunction(),
          categoryId: BuggyData?.categoryId,
          quantity: count,
          group: "Buggy",
        },
      ],
      source:
        process.env.REACT_APP_API_ENV_TYPE === "DEV" ? "EntryForm" : "OmniQR",
      paymentType: "PG",
      centerId: process.env.REACT_APP_API_ENV_TYPE === "DEV" ? 14 : 41,
      posId: process.env.REACT_APP_API_ENV_TYPE === "DEV" ? 47 : 55,
      discountPct: 0,
      name: userData[0]?.FullName,
      mobile: userData[0]?.CountryDialingCode?.toString()?.includes("+")
        ? userData[0]?.CountryDialingCode
        : "+" + userData[0]?.CountryDialingCode + userData[0]?.MobileNo,
      email: "",
      groupId: userData[0]?.GroupId,
    };
    try {
      setSecIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/items/savePurchaseData`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();

      if (result?.success) {
        setSecIsLoading(false);
        CreateOrder(
          result?.data?.billNumbers?.[0] ?? result?.data?.billNo,
          BuggyData?.trustID,
          payload?.name,
          userData[0]?.MobileNo
        );
        setIsLoading(false);
      } else {
        setSecIsLoading(false);
        console.log("error");
      }
    } catch (error) {
      setSecIsLoading(false);
      console.log(error);
    }
  };

  const PayOnlineMeals = async () => {
    setSecIsLoading(true);

    const payload = {
      items: [],
      source:
        process.env.REACT_APP_API_ENV_TYPE === "DEV" ? "EntryForm" : "OmniQR",
      paymentType: "PG",
      centerId: process.env.REACT_APP_API_ENV_TYPE === "DEV" ? 14 : 41,
      posId: process.env.REACT_APP_API_ENV_TYPE === "DEV" ? 47 : 55,
      discountPct: 0,
      name: userData[0]?.FullName,
      mobile: userData[0]?.CountryDialingCode?.toString()?.includes("+")
        ? userData[0]?.CountryDialingCode
        : "+" + userData[0]?.CountryDialingCode + userData[0]?.MobileNo,
      email: "",
      groupId: userData[0]?.GroupId,
    };

    if (mealCounts.breakfast > 0) {
      payload.items.push({
        startDate: DateFunction(),
        endDate: DateFunction(),
        categoryId: getCategoryRate("Breakfast")?.categoryId,
        quantity: mealCounts.breakfast,
        group: "Meals",
      });
    }

    

    if (mealCounts.lunch > 0) {
      payload.items.push({
        startDate: DateFunction(),
        endDate: DateFunction(),
        categoryId: getCategoryRate("Lunch")?.categoryId,
        quantity: mealCounts.lunch,
        group: "Meals",
      });
    }

   

    if (mealCounts.dinner > 0) {
      payload.items.push({
        startDate: DateFunction(),
        endDate: DateFunction(),
        categoryId: getCategoryRate("Dinner")?.categoryId,
        quantity: mealCounts.dinner,
        group: "Meals",
      });
    }

   

    try {
      setSecIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/items/savePurchaseData`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();

      if (result?.success) {
        setSecIsLoading(false);
        CreateOrder(
          result?.data?.billNumbers?.[0] ?? result?.data?.billNo,
          getCategoryRate("Dinner")?.trustID,
          payload?.name,
          userData[0]?.MobileNo
        );
        setIsLoading(false);
      } else {
        toast.error(result?.message);
        setSecIsLoading(false);
        console.log("error");
      }
    } catch (error) {
      setSecIsLoading(false);
      console.log(error);
    }
  };

  
  const CreateOrder = async (billNo, trustId, name, mobile) => {
    const payload = {
      visitorId: userData[0]?.Id,
      billNo: billNo,
      trustId: trustId,
      system:
        process.env.REACT_APP_API_ENV_TYPE === "DEV" ? "EntryForm" : "OmniQR",
      paymentType: "PG",
      outputType: "pg",
      gateway: trustId === 4 ? "razorpay" : "razorpay", //temp hardcoding till payment gateway issues are sorted
      returnUrl: `${process.env.REACT_APP_BASE_URL}visitorPortal/${passId}`,
      name: name,
      mobileNo: mobile?.length === 10 ? mobile : "9999999999",
    };

    try {
      setSecIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/createOrder`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();

      if (result?.success) {
        if (payload.gateway === "cashfree") {
          const cashfree = await load({
            mode:
              process.env.REACT_APP_API_ENV_TYPE === "LIVE"
                ? "production"
                : "sandbox",
          });
          const checkoutOptions = {
            paymentSessionId: result?.data?.data?.data?.order?.paymentSessionId,
            redirectTarget: "_self",
          };

          cashfree.checkout(checkoutOptions).then(function (result) {
            if (result?.error) {
              toast.error(result.error.message);
            }
            if (result?.redirect) {
              console.log("Redirection");
            }
            setSecIsLoading(false);
          });
        } else {
          const options = {
            key:
              trustId === 4
                ? process.env.REACT_APP_RZP_SRASSK_KEY
                : process.env.REACT_APP_RZP_SRDPS_KEY, // Sandbox key for Razorpay (replace with your actual test key)
            amount: result?.data?.data?.data?.order?.amount, // Amount is in currency subunits. Default currency is INR. Hence, 10000 refers to 100 INR
            currency: result?.data?.data?.data?.order?.currency,
            name: trustId === 4? "Meals": "Buggy Pass",
            description: result?.data?.data?.data?.order?.receipt,
            order_id: result?.data?.data?.data?.order?.id, // Pass the order ID if you have it
            handler: function (response) {
              //setLoading(true);
              setSecIsLoading(true);
              //window.location.href = `${window.location.origin}/events/${eventId}/payment-summary?order_id=${createOrderResponse.data.order_number}`;
              window.location.href = payload.returnUrl;
              //setLoading(false);
            },
            prefill: {
              name: name ?? "",
              /*email: createOrderRequest.members[0]?.wsrdt_email?.replace(/,/g, '') 
                      ?? createOrderRequest.wsrmn_email?.replace(/,/g, '') 
                      ?? '',*/
              contact: mobile ?? "",
            },
            theme: {
              color: "#c66a10",
            },
          };
          //console.log('options', options)
          const rzp1 = new window.Razorpay(options);
          rzp1.on("payment.failed", function (response) {
            console.log(response);
            //setLoading(false);
            setSecIsLoading(false);
          });
          setTimeout(() => {
            if (rzp1._state !== "paid") {
              setSecIsLoading(false);
            }
          }, 5000);
          rzp1.open();
        }
      } else {
        toast.error(result?.message);
        setSecIsLoading(false);
        console.log("error");
      }
    } catch (error) {
      setSecIsLoading(false);
      console.log(error);
    }
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Options for date and time formatting
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Use 12-hour format with AM/PM
      timeZone: "UTC", // Use UTC time zone
    };

    // Format date and time
    const formattedDateTime = date.toLocaleString("en-GB", options);

    return formattedDateTime;
  };

  function Redirect(val) {
    let url;
    if (val === "ashramImage") {
      url =
        "https://www.srmd.org/en-IN/plan-your-visit-to-shrimad-rajchandra-ashram-dharampur/#guided-ashram-tour";
    } else if (val === "ashramImageTwo") {

     url = "https://www.srmd.org/AshramDailySchedule/?type=V";
    } else if (val === "ashramImageThree") {
      url =
        "https://www.srmd.org/en-IN/plan-your-visit-to-shrimad-rajchandra-ashram-dharampur/#ashram-culture";
    }
    window.open(url, "_blank");
  }

  const BookPopupHandle = (Item) => {
    handleThirdClose();
    setTourSecPopup(Item);
  };

  // const handlePopupClose = () => {
  //   setTourSecPopup(null);
  // };

  const handleCancelClose = () => {
    setCancelTourSecPopup(null);
  };

  // const BookPopupSecHandle = (Item) => {
  //   handlePopupClose();
  //   setTourSecPopup(Item);
  // };

  const handlePopupSecClose = () => {
    setTourSecPopup(null);
    setBookCounts(0);
  };

  useEffect(() => {
    const DetailsData = async () => {
      const payload = { data: passId };
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_VMS_URL}/getVisitorDataByGroupId`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.isSuccess) {
          setIsLoading(false);
          setUserData(
            result?.data
              ?.filter((user) => user?.isDefault === 1)
              .concat(result?.data?.filter((user) => user?.isDefault !== 1))
          );
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    DetailsData();
    const BuggyItem = async () => {
      const payload = {
        posAppDisplayType: "E",
        groupId: 2,
      };
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/items`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.success) {
          setBuggyData(result?.data?.items[0]);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    BuggyItem();
    const MealsItem = async () => {
      const payload = {
        posAppDisplayType: "E",
        groupId: 1,
      };
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/items`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.success) {
          setMealsData(result?.data?.items);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    MealsItem();
    const TimeFetch = async () => {
      const payload = {};
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/print`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.success) {
          setTime(result?.data?.printFormat);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    TimeFetch();
    const TimeEnd = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/passConfigs`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const result = await response.json();
        if (result?.success) {
          setTimeEnd(result?.data?.passConfigs);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    TimeEnd();
    const LoginTour = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_ODOO_URL}/odoo_connect`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              login: `${process.env.REACT_APP_ODOO_USERNAME}`,
              password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
              db: "itportal.srmd.org",
            },
          }
        );
        const result = await response.json();
        if (result?.Status) {
          setLoginApi(result[`api-key`]);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    LoginTour();
  }, [passId]);

  const TourFetchHistory = async () => {
    const payload = {
      fields: [
        "id",
        "name",
        "email",
        "phone",
        "qty",
        "create_date",
        "event_id",
        "group_id",
      ],
      domain: [
        ["group_id", "=", userData[0]?.GroupId],
        ["state", "!=", "cancel"],
      ],
    };
    try {
      setTourLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.registration`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            login: `${process.env.REACT_APP_ODOO_USERNAME}`,
            password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
            "api-key": LoginApi,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();

      if (result?.records) {
        setTourHistoryList(result?.records);
        setTourLoading(false);
      }
    } catch (error) {
      setTourLoading(false);
      console.log(error);
    } finally {
      setTourLoading(false);
    }
  };

  useEffect(() => {
    if (userData[0]?.GroupId) {
      const TransactionHistory = async () => {
        const payload = {
          groupId: userData[0]?.GroupId,
        };
        try {
          setFourIsLoading(true);
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/transactionHistory`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );
          const result = await response.json();

          if (result?.success) {
            const sortData = result?.data?.transactionHistory.sort(
              (a, b) => new Date(b.bill_date) - new Date(a.bill_date)
            );
            const groupedBills = [];
            const billMap = new Map();

            for (const bill of sortData) {
              if (!billMap.has(bill.bill_no)) {
                billMap.set(bill.bill_no, []);
              }
              billMap.get(bill.bill_no).push(bill);
            }

            for (const billGroup of billMap.values()) {
              if (billGroup.length > 1) {
                groupedBills.push(billGroup);
              } else {
                groupedBills.push(billGroup[0]);
              }
            }
            setTransactionHistoryData(groupedBills);
            setFourIsLoading(false);
          } else {
            setFourIsLoading(false);
            console.log("error");
          }
        } catch (error) {
          setFourIsLoading(false);
          console.log(error);
        }
      };
      TransactionHistory();
      const ScanningHistory = async () => {
        const payload = {
          groupId: userData[0]?.GroupId,
        };
        try {
          setFiveIsLoading(true);
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/scanningHistory`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );
          const result = await response.json();

          if (result?.success) {
            const sortedArray = result?.data?.scanningHistory.sort(
              (a, b) =>
                new Date(`${b?.date}T${b?.time}.000Z`) -
                new Date(`${a?.date}T${a?.time}.000Z`)
            );
            setScanningHistoryData(sortedArray);
            setFiveIsLoading(false);
          } else {
            setFiveIsLoading(false);
            console.log("error");
          }
        } catch (error) {
          setFiveIsLoading(false);
          console.log(error);
        }
      };
      ScanningHistory();
    }
    const TourHistory = async () => {
      const payload = {
        fields: [
          "id",
          "name",
          "email",
          "phone",
          "qty",
          "create_date",
          "event_id",
          "group_id",
        ],
        domain: [
          ["group_id", "=", userData[0]?.GroupId],
          ["state", "!=", "cancel"],
        ],
      };
      try {
        setTourLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.registration`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              login: `${process.env.REACT_APP_ODOO_USERNAME}`,
              password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
              "api-key": LoginApi,
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.records) {
          setTourHistoryList(result?.records);
          setTourLoading(false);
        }
      } catch (error) {
        setTourLoading(false);
        console.log(error);
      } finally {
        setTourLoading(false);
      }
    };
    if (LoginApi) {
      TourHistory();
    }
  }, [userData, LoginApi]);

  const EventsListsIs = async () => {
    try {
      setIsTourLoading(true);
      const now = new Date();
      const dateBegin = new Date(now.getTime() + 15 * 60 * 1000);
      const dateEnd = new Date(now);
      dateEnd.setUTCHours(18, 30, 0, 0);
      const dateBeginISO = dateBegin.toISOString();
      const dateEndISO = dateEnd.toISOString();
      const payload = {
        fields: [
          "id",
          "name",
          "date_begin",
          "date_end",
          "stage_id",
          "address_id",
        ],
        domain: [
          ["date_begin", ">=", dateBeginISO],
          ["date_end", "<=", dateEndISO],
          ["stage_id", "not in", [4, 5]],
        ],
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.event`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            login: `${process.env.REACT_APP_ODOO_USERNAME}`,
            password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
            "api-key": LoginApi,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (result?.records) {
        setTourList(result?.records);
        setIsTourLoading(false);
      } else {
        setIsTourLoading(false);
        console.log("error");
      }
    } catch (error) {
      setIsTourLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    const FetchHistoryDetails = async (id, name) => {
      const payload = {
        fields: [
          "id",
          "name",
          "date_begin",
          "date_end",
          "stage_id",
          "address_id",
        ],
      };
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ODOO_URL}/send_request?model=event.event&Id=${id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              login: `${process.env.REACT_APP_ODOO_USERNAME}`,
              password: `${process.env.REACT_APP_ODOO_PASSWORD}`,
              "api-key": LoginApi,
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.records) {
          setTourHistoryListById((prevData) => ({
            ...prevData,
            [name]: result?.records,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (TourHistoryList?.length > 0 && LoginApi) {
      TourHistoryList.forEach((tour) => {
        const eventId = tour?.event_id?.[0];
        const name = tour?.name;
        if (eventId && name) {
          FetchHistoryDetails(eventId, name);
        } else {
          console.error("Error: Missing eventId or name for tour:", tour);
        }
      });
    }
  }, [TourHistoryList, LoginApi]);

  useEffect(() => {
    if (userData?.length > 0) {
      const imageUrls = userData?.map((user) => user?.qrString);
      preloadImages(imageUrls);
    }
  }, [userData]);

  useEffect(() => {
    function isWithinTimeFrame(name) {
      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();
      const currentSeconds = now.getSeconds();
      const currentTime = `${String(currentHours).padStart(2, "0")}:${String(
        currentMinutes
      ).padStart(2, "0")}:${String(currentSeconds).padStart(2, "0")}`;
      const CategoryData = MealsData?.find(
        (meal) => meal?.categoryName === name
      );
      const CategoryId = CategoryData?.categoryId;
      const category = TimeEnd?.find((c) => c.CategoryId === CategoryId);

      if (!category || !category.PurchaseEndTime) return false;

      const endTime = category.PurchaseEndTime.split("T")[1].substring(0, 8);
      const isWithinTime = currentTime < endTime;
      console.log(name, currentTime, endTime);
      setMealShows((prevState) => ({ ...prevState, [name]: isWithinTime }));
    }
    isWithinTimeFrame("Breakfast");
    isWithinTimeFrame("Lunch");
    isWithinTimeFrame("Dinner");
  }, [TimeEnd, MealsData]);

  useEffect(() => {
    if (userData?.length > 0) {
      // setMaxBookCounts(userData?.length);
      setMaxBookCounts(100);
    }
  }, [userData]);

  useEffect(() => {
    if(userData?.length > 0){
      const imageUrls = userData?.map(user => user.qrString);
      preloadImages(imageUrls)
    }
  }, [userData]);

  return (
    <>
      <Helmet>
        <title>Shrimad Rajchandra Mission Dharampur - DashBoard</title>{" "}
        {/* Set specific title for EPassPage */}
      </Helmet>
      <div
        className={`bg-[#FAF6EF] h-auto min-h-screen ${
          windowWidth >= 1300 ? "lg:px-[20rem]" : "lg:px-[12rem]"
        }`}
      >
        <div className="flex flex-col gap-4 justify-center items-center ">
          <div className="w-2/3 sm:w-1/2 p-1">
            <img src={logo} alt="mission_logo" className="w-full h-full p-1" />
            <LanguageToggle />
          </div>
        </div>
        {isLoading && (
          <div className="flex items-center justify-center mt-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        )}
        {userData?.length > 0 && !isLoading && (
          <div className="relative">
            <div
              className="relative bg-[#efede7] mt-10"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
                <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5 ">
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  <h5 className="text-white px-4">{t.dashboard}</h5>
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                </div>
              </div>
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col  primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text pt-8 shadow-lg">
                    {userData?.map(
                      (user, index) =>
                        index === currentIndex && (
                          <div className="flex">
                            <div className="rounded-3xl  bg-[#EBD3B4] p-3 mt-0 sm:mt-2 max-w-[40%]">
                              <img
                                src={user?.qrString}
                                alt="Scanner"
                                className="w-44 sm:w-42 h-42 cursor-pointer"
                                onClick={() => {
                                  setSelectedImage(user?.qrString);
                                }}
                              />
                            </div>
                            <div className="rounded-3xl p-3 flex flex-col items-start justify-center max-w-[60%] flex-wrap">
                              <span
                                className="text-[#c66a10] text-xl sm:text-2xl font-semibold   capitalize overflow-wrap break-word word-break: break-all max-w-full"
                                title={user?.FullName}
                              >
                                {user?.FullName}
                              </span>
                              <span className="text-[#333333] text-sm sm:text-xl font-semibold truncate capitalize">
                                {(user?.Age ?? 0) !== 0 && `${user?.Age ?? 0},`}
                                {user?.Gender === "M" ? "Male" : "Female"}
                              </span>
                              <span className="text-[#333333] text-sm sm:text-xl font-semibold truncate capitalize">
                                {user?.City === "-" ? "" : `${user?.City}`}
                              </span>
                            </div>
                          </div>
                        )
                    )}
                    {userData?.length > 1 && (
                      <div className="flex justify-center">
                        {userData?.map((_, index) => (
                          <div
                            key={index}
                            className={`rounded-full ${
                              index === currentIndex
                                ? "bg-[#c66a10] w-4 h-2"
                                : "bg-white w-2 h-2 border border-[#c66a10]"
                            } mx-1`}
                          />
                        ))}
                      </div>
                    )}
                    <span className="text-[#8E4D0E] text-xs sm:text-sm font-semibold capitalize flex items-center justify-center gap-2 mt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12s12-5.383 12-12h-2.7c0 5.128-4.172 9.3-9.3 9.3S2.7 17.128 2.7 12S6.872 2.7 12 2.7zm7.4 2.583l-7.505 9.371L8.388 9.08l-2.002 2.436l4.741 3.888a1.573 1.573 0 0 0 2.231-.233l8.504-10.617z"
                        />
                      </svg>
                      {t.HeadLine}
                    </span>
                  </div>
                </div>
              </div>
              {/* <div className="absolute -bottom-4 sm:-bottom-2 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
                {userData?.length > 1 && (
                  <div className="flex justify-center mb-5">
                    {userData?.map((_, index) => (
                      <div
                        key={index}
                        className={`rounded-full ${
                          index === currentIndex
                            ? "bg-[#c66a10] w-4 h-2"
                            : "bg-white w-2 h-2 border border-[#c66a10]"
                        } mx-1`}
                      />
                    ))}
                  </div>
                )}
              </div> */}
            </div>
            <span className="hidden sm:block">
              {currentIndex !== 0 && (
                <div className="absolute top-1/2 left-20 transform -translate-y-1/2 flex items-center">
                  <button
                    onClick={handlePrevious}
                    className={`slide-button flex flex-col items-center gap-2 text-[#c66a10] font-medium p-2 rounded-full`}
                    style={{
                      animationName:
                        slideDirection === "left" ? "slide-in-left-button" : "",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-10 h-10 font-bold text-lg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                    {t.prvBtn}
                  </button>
                </div>
              )}
              {currentIndex !== userData?.length - 1 && (
                <div className="absolute top-1/2 right-20 transform -translate-y-1/2 flex items-center slide-button">
                  <button
                    onClick={handleNext}
                    className={`slide-button flex flex-col items-center gap-2 text-[#c66a10] font-medium p-2 rounded-full`}
                    style={{
                      animationName:
                        slideDirection === "right"
                          ? "slide-in-right-button"
                          : "",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-10 h-10 font-bold text-lg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                    {t.nextBtn}
                  </button>
                </div>
              )}
            </span>
          </div>
        )}
        {userData?.length > 0 && (
          <div className="relative">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-2 sm:p-3 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex gap-2 w-full justify-center items-center">
                      <span className="text-[#c66a10] text-sm sm:text-lg  font-medium ">
                        {t.MealsTimingHead}
                      </span>
                      <svg
                        class="w-5 h-5  fill-[#c66a10] cursor-pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        onClick={handleSvgClick}
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.88-13h1.75c.41 0 .75.34.75.75s-.34.75-.75.75h-1.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75zm1.06 11h-1.25c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75h1.25c.41 0 .75.34.75.75v6c0 .41-.34.75-.75.75z" />
                      </svg>
                    </div>
                    {isMealsOpen && (
                      <div className="mt-4 p-1">
                        <div className="flex flex-col gap-2 w-full justify-between items-center">
                          {[
                            {
                              label: t.meals.breakfastSDescription,
                              categoryName: "Breakfast",
                            },
                            
                            {
                              label: t.meals.lunchSDescription,
                              categoryName: "Lunch",
                            },
                            
                            {
                              label: t.meals.dinnerSDescription,
                              categoryName: "Dinner",
                            },
                           
                          ]
                            .filter(
                              ({ categoryName }) =>
                                !!formatMealTimeHeader(categoryName)
                            )
                            .map(({ label, categoryName }) => (
                              <div
                                key={categoryName}
                                className="flex gap-2 w-full justify-between items-start"
                              >
                                <span className="text-[#c66a10] text-sm sm:text-lg  font-medium ">
                                  {label}
                                </span>
                                <span className="text-[#c66a10] text-sm sm:text-lg  font-medium ">
                                  {formatMealTimeHeader(categoryName)}
                                </span>
                              </div>
                            ))}
                        </div>
                        <div className="flex gap-2 w-full justify-start items-start mt-1">
                          <span className="text-[#c66a10] text-xs sm:text-sm  font-medium ">
                            {t.MealsTimingNote}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isFourLoading && TransactionHistoryData?.length > 0 && (
          <div className="flex items-center justify-center mt-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        )}
        {!isFourLoading && TransactionHistoryData?.length > 0 && (
          <div className="relative">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex w-full justify-between">
                      <div className="flex w-[80%] justify-start items-center ">
                        <img className="w-7 h-7" alt="logo" src={clock} />
                        <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold w-full">
                          {t.THistory}
                        </span>
                      </div>
                      <div className="flex w-[20%] text-[#999999] text-sm sm:text-md justify-end items-center ">
                        <span
                          className="border-b-2 cursor-pointer"
                          onClick={() => {
                            handleViewAllClick("/transactionHistory");
                          }}
                        >
                          {t.View}
                        </span>
                      </div>
                    </div>
                    {TransactionHistoryData?.length === 0 && (
                      <div className="flex items-center justify-center mt-4 text-[#BD6A01] text-md sm:text-lg font-semibold">
                        {t.NoTData}
                      </div>
                    )}
                    {TransactionHistoryData?.length > 0 &&
                      TransactionHistoryData?.slice(0, 4)?.map(
                        (billNo, index) =>
                          !Array.isArray(billNo) &&
                          billNo?.categoryName === "Buggy Pass" ? (
                            <div className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl">
                              <div className="flex  flex-col  w-full gap-1">
                                <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                                  <span className="text-[#BD6A01] text-xs sm:text-lg font-medium flex justify-start items-center w-[80%]">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      className="w-5 h-5"
                                    >
                                      <g fill="none">
                                        <path
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M6 19a2 2 0 0 1-2-2v-4m2 6v1.5a.5.5 0 0 0 .5.5v0a.5.5 0 0 0 .5-.5V19m-1 0h1m11 0a2 2 0 0 0 2-2v-4m-2 6v1.5a.5.5 0 0 1-.5.5v0a.5.5 0 0 1-.5-.5V19m1 0h-1M4 13V7m0 6h8m8 0V7m0 6h-8m-5 6h10M4 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2M4 7h8m8 0h-8m0 0v6"
                                        />
                                        <path
                                          fill="currentColor"
                                          fill-rule="evenodd"
                                          d="M4 13h16v6H4zm3 3a1 1 0 0 1 1-1h.001a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m9-1a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2z"
                                          clip-rule="evenodd"
                                        />
                                        <path
                                          fill="currentColor"
                                          d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H4z"
                                        />
                                      </g>
                                    </svg>
                                    <span className="text-xs sm:text-lg  uppercase ">
                                      {billNo?.quantity}{" "}
                                      {billNo?.quantity === 1
                                        ? `${t.meals[`buggy pass`]}`
                                        : `${t.buggy} ${t.DailyPasses}`}
                                    </span>
                                  </span>
                                  <span className="text-[#c66a10] text-xl sm:text-3xl font-medium w-[20%]">
                                    <span>₹{billNo?.total_amount}</span>
                                  </span>
                                </span>
                                <span className="text-[#999999] font-medium flex -mt-2 pl-1">
                                  <span className="text-xs sm:text-md">
                                    {formatDateTime(billNo?.bill_date)}
                                  </span>
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl">
                              <div className="flex  flex-col  w-full gap-1">
                                <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                                  <span className="text-[#BD6A01] text-xs sm:text-lg font-medium flex justify-start items-center w-[80%]">
                                    <img
                                      className="w-6 h-6"
                                      alt="logo"
                                      src={meal}
                                    />
                                    {Array.isArray(billNo) ? (
                                      billNo.map((item, index) => (
                                        <span
                                          key={item.categoryName}
                                          className="text-xs sm:text-lg uppercase"
                                        >
                                          {item.quantity}{" "}
                                          {
                                            t.meals[
                                              item.categoryName.toLowerCase()
                                            ]
                                          }
                                          {index < billNo.length - 1 && ", "}
                                        </span>
                                      ))
                                    ) : (
                                      <span className="text-xs sm:text-lg uppercase">
                                        {billNo.quantity}{" "}
                                        {
                                          t.meals[
                                            billNo.categoryName.toLowerCase()
                                          ]
                                        }
                                      </span>
                                    )}
                                  </span>
                                  <span className="text-[#c66a10] text-xl sm:text-3xl font-medium w-[20%]">
                                    <span>
                                      ₹
                                      {Array.isArray(billNo)
                                        ? billNo[0]?.total_amount
                                        : billNo?.total_amount}
                                    </span>
                                  </span>
                                </span>
                                <span className="text-[#999999] font-medium flex -mt-2 pl-1">
                                  <span className="text-xs sm:text-md">
                                    {formatDateTime(
                                      Array.isArray(billNo)
                                        ? billNo[0]?.bill_date
                                        : billNo?.bill_date
                                    )}
                                  </span>
                                </span>
                              </div>
                            </div>
                          )
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {userData?.length > 0 && (
          <div className="relative">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex w-full justify-center items-center">
                      <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold ">
                        {t.buggy}
                      </span>
                      <div className="w-[80%] ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="2em"
                          height="2em"
                          viewBox="0 0 512 512"
                          className="bus-animation"
                        >
                          <path
                            fill="#c66a10"
                            d="M441.884 109.647A32.029 32.029 0 0 0 415.669 96H48a32.036 32.036 0 0 0-32 32v248h41.082a67.982 67.982 0 0 0 133.836 0h122.164a67.982 67.982 0 0 0 133.836 0H496V194.521a23.886 23.886 0 0 0-4.338-13.763ZM180 128h144v96H180Zm-132 0h100v96H48Zm76 272a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36m256 0a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36m84-56h-19.006a68 68 0 0 0-129.988 0H188.994a68 68 0 0 0-129.988 0H48v-88h416Zm0-120H356v-96h59.669L464 197.043Z"
                          />
                        </svg>
                      </div>
                    </div>
                    <span className="text-[#333333] text-sm sm:text-lg  font-medium mt-2">
                      {t.buggyContent}
                    </span>
                    <span className="flex items-center justify-center ">
                      <button
                        onClick={handleOpen}
                        className="flex items-center justify-center bg-[#c66a10] p-2 px-4 w-[260px] text-white rounded-3xl mt-5  font-medium cursor-pointer"
                      >
                        {t.buyDailyPass}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {userData?.length > 0 && (
          <div className="relative">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex w-full justify-start items-center">
                      <img className="w-8 h-8" alt="logo" src={meal} />
                      <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold ">
                        {t.mealTitle}
                      </span>
                    </div>
                    <span className="text-[#333333] text-sm sm:text-lg  font-medium mt-2">
                      {t.purchaseC}
                    </span>
                    <span className="flex items-center justify-center ">
                      <button
                        onClick={handleSecOpen}
                        className="flex items-center justify-center bg-[#c66a10] p-2 px-4 w-[260px] text-white rounded-3xl mt-5  font-medium cursor-pointer"
                      >
                        {t.Buy}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* change here */}
        {TourLoading && TourEnable && (
          <div className="flex items-center justify-center mt-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        )}
        {userData?.length > 0 && TourEnable &&
          !TourLoading &&
          TourHistoryList?.length === 0 && TourEnable && (
            <div className="relative">
              <div className="relative bg-[#efede7] mt-6">
                <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                  <div className="w-[90%] sm:w-[60%]">
                    <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                      <div className="flex w-full justify-start items-center">
                        <img className="w-7 h-7" alt="logo" src={ashramTour} />
                        <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold ">
                          {t.Ashram.tour}
                        </span>
                      </div>
                      <span className="text-[#333333] text-sm sm:text-lg  font-medium mt-2">
                        {t.TourLine}
                      </span>
                      <span className="flex items-center justify-center ">
                        <button
                          onClick={handleThirdOpen}
                          className="flex items-center justify-center bg-[#c66a10] p-2 px-4 w-[260px] text-white rounded-3xl mt-5  font-medium cursor-pointer"
                        >
                          {t.TourButton}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        {userData?.length > 0 &&
          !TourLoading &&
          TourHistoryList?.length > 0 && (
            <>
              <div className="relative">
                <div className="relative bg-[#efede7] mt-6">
                  <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                    <div className="w-[90%] sm:w-[60%]">
                      <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                        <div className="flex w-full justify-start items-center">
                          <img
                            className="w-7 h-7"
                            alt="logo"
                            src={ashramTour}
                          />
                          <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold ">
                            {t.Ashram.tour}
                          </span>
                          <img
                            className="w-7 h-7 ml-1"
                            src={Gif}
                            alt="description of gif"
                          />
                        </div>
                        {TourHistoryList.map((tour, index) => (
                          <div key={index}>
                            <div className="flex justify-start items-center gap-2 cursor-pointer">
                              <span className="text-[#333333] text-sm sm:text-lg  font-medium mt-2">
                                {tour?.name ? tour?.name : "Ashram Tour"}
                              </span>
                            </div>
                            <div className="flex justify-between mt-1">
                              <span className="text-[#333333] text-xs sm:text-md  font-medium mt-2 flex gap-1 justify-center items-center">
                                <img
                                  className="w-5 h-5 sm:w-7 sm:h-7"
                                  alt="logo"
                                  src={people}
                                />
                                {tour?.qty}{" "}
                                {tour?.qty === 1 ? t.People : t.Peoples}
                              </span>
                              <span className="text-[#333333] text-xs sm:text-md  font-medium mt-2 flex gap-1 justify-center items-center">
                                <img
                                  className="w-4 h-4 sm:w-6 sm:h-6"
                                  alt="logo"
                                  src={GroupClock}
                                />
                                {TourHistoryListById[tour?.name] &&
                                  TourHistoryListById[tour?.name]?.[0] && (
                                    <div>
                                      {new Date(
                                        new Date(
                                          TourHistoryListById[
                                            tour?.name
                                          ][0]?.date_begin
                                        ).getTime() +
                                          5.5 * 60 * 60 * 1000
                                      )
                                        .toLocaleString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })
                                        .replace("AM", "a.m.")
                                        .replace("PM", "p.m.")}{" "}
                                      -
                                      {new Date(
                                        new Date(
                                          TourHistoryListById[
                                            tour?.name
                                          ][0]?.date_end
                                        ).getTime() +
                                          5.5 * 60 * 60 * 1000
                                      )
                                        .toLocaleString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })
                                        .replace("AM", "a.m.")
                                        .replace("PM", "p.m.")}
                                    </div>
                                  )}
                              </span>
                              <span className="text-[#333333] text-xs sm:text-md  font-medium mt-2 flex gap-1  justify-center items-center">
                                <img
                                  className="w-5 h-5 sm:w-7 sm:h-7"
                                  alt="logo"
                                  src={navigation}
                                />
                                {
                                  // Safely access address_id[1] only if all intermediate values exist
                                  TourHistoryListById?.[tour?.name]?.[0]
                                    ?.address_id?.[1]
                                    ? TourHistoryListById[tour.name][0]
                                        .address_id[1]
                                    : null // Fallback text in case address_id[1] is undefined
                                }
                              </span>
                              {isCancelLoading !== tour?.id && (
                                <svg
                                  xmlns=""
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="2"
                                  stroke="currentColor"
                                  class="w-5 h-5 text-white  mt-3 bg-[#c66a10] hover:bg-[#ff9900] rounded-full p-1 cursor-pointer"
                                  onClick={() => {
                                    setCancelTourSecPopup(tour);
                                  }}
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              )}
                            </div>
                          </div>
                        ))}

                        <span className="flex items-center justify-center ">
                          <button
                            onClick={handleThirdOpen}
                            className="flex items-center justify-center bg-[#c66a10] p-2 px-4 w-[260px] text-white rounded-3xl mt-5  font-medium cursor-pointer"
                          >
                            {t.BookAgain}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        {TourEnable && <div className="relative">
          <div className="relative bg-[#efede7] mt-6">
            <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
              <div className="w-[95%] sm:w-[60%] flex justify-between">
                <img
                  className="cursor-pointer w-1/2"
                  alt="logo"
                  src={ashramImageTwo}
                  onClick={() => {
                    Redirect("ashramImageTwo");
                  }}
                />
                <img
                  className="cursor-pointer w-1/2"
                  alt="logo"
                  src={ashramImageThree}
                  onClick={() => {
                    Redirect("ashramImageThree");
                  }}
                />
              </div>
            </div>
          </div>
        </div>}
        {!TourEnable &&<div className="relative">
          <div className="relative bg-[#efede7] mt-4">
            <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
              <div className="w-[90%] sm:w-[60%] flex justify-between">
                <img
                  className="w-28 sm:w-32 h-28 sm:h-32 cursor-pointer"
                  alt="logo"
                  src={ashramImage}
                  onClick={() => {
                    Redirect("ashramImage");
                  }}
                />
                <img
                  className="w-28 sm:w-32 h-28 sm:h-32 cursor-pointer"
                  alt="logo"
                  src={ashramImageTwoold}
                  onClick={() => {
                    Redirect("ashramImageTwo");
                  }}
                />
                <img
                  className="w-28 sm:w-32 h-28 sm:h-32 cursor-pointer"
                  alt="logo"
                  src={ashramImageThreeold}
                  onClick={() => {
                    Redirect("ashramImageThree");
                  }}
                />
              </div>
            </div>
          </div>
        </div>}
        {isFourLoading && TransactionHistoryData?.length === 0 && (
          <div className="flex items-center justify-center mt-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        )}
        {!isFourLoading && TransactionHistoryData?.length === 0 && (
          <div className="relative">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex w-full justify-between">
                      <div className="flex w-[80%] justify-start items-center ">
                        <img className="w-7 h-7" alt="logo" src={clock} />
                        <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold w-full">
                          {t.THistory}
                        </span>
                      </div>
                      <div className="flex w-[20%] text-[#999999] text-sm sm:text-md justify-end items-center ">
                        <span
                          className="border-b-2 cursor-pointer"
                          onClick={() => {
                            handleViewAllClick("/transactionHistory");
                          }}
                        >
                          {t.View}
                        </span>
                      </div>
                    </div>
                    {TransactionHistoryData?.length === 0 && (
                      <div className="flex items-center justify-center mt-4 text-[#BD6A01] text-md sm:text-lg font-semibold">
                        {t.NoTData}
                      </div>
                    )}
                    {TransactionHistoryData?.length > 0 &&
                      TransactionHistoryData?.slice(0, 4)?.map(
                        (billNo, index) =>
                          !Array.isArray(billNo) &&
                          billNo?.categoryName === "Buggy Pass" ? (
                            <div className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl">
                              <div className="flex  flex-col  w-full gap-1">
                                <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                                  <span className="text-[#BD6A01] text-xs sm:text-lg font-medium flex justify-start items-center w-[80%]">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      className="w-5 h-5"
                                    >
                                      <g fill="none">
                                        <path
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M6 19a2 2 0 0 1-2-2v-4m2 6v1.5a.5.5 0 0 0 .5.5v0a.5.5 0 0 0 .5-.5V19m-1 0h1m11 0a2 2 0 0 0 2-2v-4m-2 6v1.5a.5.5 0 0 1-.5.5v0a.5.5 0 0 1-.5-.5V19m1 0h-1M4 13V7m0 6h8m8 0V7m0 6h-8m-5 6h10M4 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2M4 7h8m8 0h-8m0 0v6"
                                        />
                                        <path
                                          fill="currentColor"
                                          fill-rule="evenodd"
                                          d="M4 13h16v6H4zm3 3a1 1 0 0 1 1-1h.001a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m9-1a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2z"
                                          clip-rule="evenodd"
                                        />
                                        <path
                                          fill="currentColor"
                                          d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H4z"
                                        />
                                      </g>
                                    </svg>
                                    <span className="text-xs sm:text-lg  uppercase ">
                                      {billNo?.quantity}{" "}
                                      {billNo?.quantity === 1
                                        ? `${t.meals[`buggy pass`]}`
                                        : `${t.buggy} ${t.DailyPasses}`}
                                    </span>
                                  </span>
                                  <span className="text-[#c66a10] text-xl sm:text-3xl font-medium w-[20%]">
                                    <span>₹{billNo?.total_amount}</span>
                                  </span>
                                </span>
                                <span className="text-[#999999] font-medium flex -mt-2 pl-1">
                                  <span className="text-xs sm:text-md">
                                    {formatDateTime(billNo?.bill_date)}
                                  </span>
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl">
                              <div className="flex  flex-col  w-full gap-1">
                                <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                                  <span className="text-[#BD6A01] text-xs sm:text-lg font-medium flex justify-start items-center w-[80%]">
                                    <img
                                      className="w-6 h-6"
                                      alt="logo"
                                      src={meal}
                                    />
                                    {Array.isArray(billNo) ? (
                                      billNo.map((item, index) => (
                                        <span
                                          key={item.categoryName}
                                          className="text-xs sm:text-lg uppercase"
                                        >
                                          {item.quantity}{" "}
                                          {
                                            t.meals[
                                              item.categoryName.toLowerCase()
                                            ]
                                          }
                                          {index < billNo.length - 1 && ", "}
                                        </span>
                                      ))
                                    ) : (
                                      <span className="text-xs sm:text-lg uppercase">
                                        {billNo.quantity}{" "}
                                        {
                                          t.meals[
                                            billNo.categoryName.toLowerCase()
                                          ]
                                        }
                                      </span>
                                    )}
                                  </span>
                                  <span className="text-[#c66a10] text-xl sm:text-3xl font-medium w-[20%]">
                                    <span>
                                      ₹
                                      {Array.isArray(billNo)
                                        ? billNo[0]?.total_amount
                                        : billNo?.total_amount}
                                    </span>
                                  </span>
                                </span>
                                <span className="text-[#999999] font-medium flex -mt-2 pl-1">
                                  <span className="text-xs sm:text-md">
                                    {formatDateTime(
                                      Array.isArray(billNo)
                                        ? billNo[0]?.bill_date
                                        : billNo?.bill_date
                                    )}
                                  </span>
                                </span>
                              </div>
                            </div>
                          )
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isFiveLoading && (
          <div className="flex items-center justify-center mt-10">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        )}
        {!isFiveLoading && (
          <div className="relative pb-3">
            <div className="relative bg-[#efede7] mt-6">
              <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
                <div className="w-[90%] sm:w-[60%]">
                  <div className="rounded-3xl bg-white flex flex-col primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text  shadow-lg">
                    <div className="flex w-full justify-between">
                      <div className="flex w-[80%] justify-start items-center ">
                        <img className="w-7 h-7" alt="logo" src={clock} />
                        <span className="text-[#c66a10] text-lg sm:text-2xl font-semibold w-full">
                          {t.SHistory}
                        </span>
                      </div>
                      <div className="flex w-[20%] text-[#999999] text-sm sm:text-md justify-end items-center ">
                        <span
                          className="border-b-2 cursor-pointer"
                          onClick={() => {
                            handleViewAllClick("/scanningHistory");
                          }}
                        >
                          {t.View}
                        </span>
                      </div>
                    </div>
                    {ScanningHistoryData?.length === 0 && (
                      <div className="flex items-center justify-center mt-4 text-[#BD6A01] text-md sm:text-lg font-semibold">
                        {t.NoSData}
                      </div>
                    )}
                    {ScanningHistoryData?.length > 0 &&
                      ScanningHistoryData?.slice(0, 4)?.map((billNo, index) => (
                        <div
                          key={index}
                          className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl"
                        >
                          <div className="flex  flex-col  w-full gap-1">
                            <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full items-center ">
                              <div className="flex justify-center items-center  gap-1">
                                {billNo?.categoryName === "Buggy Pass" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    className="w-5 h-5"
                                  >
                                    <g fill="none">
                                      <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M6 19a2 2 0 0 1-2-2v-4m2 6v1.5a.5.5 0 0 0 .5.5v0a.5.5 0 0 0 .5-.5V19m-1 0h1m11 0a2 2 0 0 0 2-2v-4m-2 6v1.5a.5.5 0 0 1-.5.5v0a.5.5 0 0 1-.5-.5V19m1 0h-1M4 13V7m0 6h8m8 0V7m0 6h-8m-5 6h10M4 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2M4 7h8m8 0h-8m0 0v6"
                                      />
                                      <path
                                        fill="currentColor"
                                        fill-rule="evenodd"
                                        d="M4 13h16v6H4zm3 3a1 1 0 0 1 1-1h.001a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m9-1a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2z"
                                        clip-rule="evenodd"
                                      />
                                      <path
                                        fill="currentColor"
                                        d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H4z"
                                      />
                                    </g>
                                  </svg>
                                ) : (
                                  <img
                                    className="w-6 h-6"
                                    alt="logo"
                                    src={meal}
                                  />
                                )}

                                <span className="text-xs sm:text-lg  uppercase ">
                                  {t.meals[billNo?.categoryName?.toLowerCase()]}
                                </span>
                              </div>
                              <span className="text-[#999999]  text-xs sm:text-md">
                                {formatDateTime(
                                  `${billNo?.date}T${billNo?.time}.000Z`
                                )}
                              </span>
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isOpen && (
          <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center cursor-pointer"
            onClick={handleClose}
          >
            <div
              className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 flex flex-col z-100 drop-shadow-lg ${
                window.innerWidth >= 1300 && "w-[40%]"
              } ${
                window.innerWidth < 1300 &&
                window.innerWidth > 1000 &&
                "w-[60%]"
              } ${
                window.innerWidth < 1000 && "w-full"
              }  min-h-[50%] sm:min-h-[40%] rounded-t-3xl bg-white cursor-default ${
                isOpen ? "animate-slideIn" : "animate-slideOut"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
                <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5 ">
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  <h3 className="text-white px-4">{t.buggy}</h3>
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                </div>
              </div>
              <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-7">
                {t.buggyContent}
              </span>
              <div className="flex pt-3 gap-2">
                <div className="w-[60%] sm:w-[50%] bg-[#EBD3B4] flex justify-between px-3 py-1 rounded-r-3xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2em"
                    height="2em"
                    viewBox="0 0 512 512"
                    className="small-bus-animation"
                  >
                    <path
                      fill="#c66a10"
                      d="M441.884 109.647A32.029 32.029 0 0 0 415.669 96H48a32.036 32.036 0 0 0-32 32v248h41.082a67.982 67.982 0 0 0 133.836 0h122.164a67.982 67.982 0 0 0 133.836 0H496V194.521a23.886 23.886 0 0 0-4.338-13.763ZM180 128h144v96H180Zm-132 0h100v96H48Zm76 272a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36m256 0a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36m84-56h-19.006a68 68 0 0 0-129.988 0H188.994a68 68 0 0 0-129.988 0H48v-88h416Zm0-120H356v-96h59.669L464 197.043Z"
                    />
                  </svg>
                  <span className="text-[#c66a10] text-lg sm:text-xl font-semibold font-sans z-100">
                    ₹{BuggyData?.categoryRate}/day
                  </span>
                </div>
                <div
                  className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[45%] bg-[#c66a10] text-white ${
                    shake && "shake"
                  }`}
                >
                  <button
                    className="text-2xl font-bold cursor-pointer"
                    onClick={(e) => {
                      handleDecrement();
                      e.stopPropagation();
                    }}
                  >
                    -
                  </button>
                  <span className="text-2xl font-bold mx-4">{count}</span>
                  <button
                    className="text-2xl font-bold cursor-pointer"
                    onClick={(e) => {
                      handleIncrement();
                      e.stopPropagation();
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="flex  justify-between  ">
                <span className="text-[#c66a10]  text-xs sm:text-sm font-medium px-5 pt-7">
                  {t.subTotal}
                </span>
                <span className="text-[#c66a10] text-2xl sm:text-3xl font-medium px-5 pt-7">
                  {count * BuggyData?.categoryRate === 0 ? (
                    <span>-</span>
                  ) : (
                    <span>₹{count * BuggyData?.categoryRate}</span>
                  )}
                </span>
              </div>
              <div className="flex  justify-center items-center">
                {isSecLoading && (
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                )}
                {!isSecLoading && (
                  <button
                    className={`drop-shadow-lg rounded-3xl w-[50%] sm:w-[45%] bg-[#c66a10] text-white py-2 ${
                      count === 0 ? "opacity-70  cursor-default" : "shadow-lg"
                    }`}
                    onClick={count !== 0 ? PayOnlineBuggy : null}
                  >
                    {t.payOnline}
                  </button>
                )}
              </div>
              <div className="flex  justify-center items-center">
                <span className="text-xs sm:text-sm font-medium px-7 py-3 opacity-70">
                  {t.Note}
                </span>
              </div>
            </div>
          </div>
        )}
        {isSecOpen && (
          <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center cursor-pointer"
            onClick={handleSecClose}
          >
            <div
              className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 flex flex-col z-100 drop-shadow-lg  ${
                window.innerWidth >= 1300 && "w-[40%]"
              } ${
                window.innerWidth < 1300 &&
                window.innerWidth > 1000 &&
                "w-[60%]"
              } ${
                window.innerWidth < 1000 && "w-full"
              }  min-h-[50%] sm:min-h-[40%] rounded-t-3xl bg-white cursor-default ${
                isSecOpen ? "animate-slideIn" : "animate-slideOut"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
                <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5 ">
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  <h5 className="text-white px-4">{t.mealTitle}</h5>
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                </div>
              </div>
              <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-7">
                {t.purchaseC}
              </span>
              
              {mealShows?.Breakfast &&
                getCategoryRate("Breakfast")?.categoryRate > 0 && (
                  <div className="flex  justify-between  bg-[#F6F6F6] mx-5 mt-3 p-2 rounded-2xl">
                    <div className="flex  flex-col  w-full gap-1">
                      <span className="text-[#BD6A01] text-sm sm:text-md  font-medium">
                        {t.meals.breakfast}
                      </span>
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                        <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.5em"
                            height="1.5em"
                            viewBox="0 0 1024 1024"
                          >
                            <path
                              fill="currentColor"
                              d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                            />
                            <path
                              fill="currentColor"
                              d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                            />
                          </svg>
                          <span className="text-sm sm:text-md">
                            {getCategoryTime(
                              getCategoryRate("Breakfast")?.categoryId
                            )
                              ?.header?.replace("Breakfast (", "")
                              .replace(")", "")
                              .replace(/(am|pm)/g, " $1")
                              .replace("-", " - ")}
                          </span>
                        </span>
                        <div
                          className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[25%] bg-[#c66a10] text-white ${
                            mealshake.breakfast && "shake"
                          }`}
                        >
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealDecrement("breakfast");
                              e.stopPropagation();
                            }}
                          >
                            -
                          </button>
                          <span className="text-2xl font-bold mx-4">
                            {mealCounts.breakfast}
                          </span>
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealIncrement("breakfast");
                              e.stopPropagation();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </span>
                      <span className="text-[#BD6A01] font-medium flex -mt-3 ">
                        <span className="text-lg sm:text-xl">
                          ₹{getCategoryRate("Breakfast")?.categoryRate}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
            
              {mealShows?.Lunch &&
                getCategoryRate("Lunch")?.categoryRate > 0 && (
                  <div className="flex  justify-between  bg-[#F6F6F6] mx-5 mt-3 p-2 rounded-2xl">
                    <div className="flex  flex-col  w-full gap-1">
                      <span className="text-[#BD6A01] text-sm sm:text-md  font-medium">
                        {t.meals.lunch}
                      </span>
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                        <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.5em"
                            height="1.5em"
                            viewBox="0 0 1024 1024"
                          >
                            <path
                              fill="currentColor"
                              d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                            />
                            <path
                              fill="currentColor"
                              d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                            />
                          </svg>
                          <span className="text-sm sm:text-md">
                            {getCategoryTime(
                              getCategoryRate("Lunch")?.categoryId
                            )
                              ?.header?.replace("Lunch (", "")
                              .replace(")", "")
                              .replace(/(am|pm)/g, " $1")
                              .replace("-", " - ")}
                          </span>
                        </span>
                        <div
                          className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[25%] bg-[#c66a10] text-white ${
                            mealshake.lunch && "shake"
                          }`}
                        >
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealDecrement("lunch");
                              e.stopPropagation();
                            }}
                          >
                            -
                          </button>
                          <span className="text-2xl font-bold mx-4">
                            {mealCounts?.lunch}
                          </span>
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealIncrement("lunch");
                              e.stopPropagation();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </span>
                      <span className="text-[#BD6A01] font-medium flex -mt-3 ">
                        <span className="text-lg sm:text-xl">
                          ₹{getCategoryRate("Lunch")?.categoryRate}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
             
              {mealShows?.Dinner &&
                getCategoryRate("Dinner")?.categoryRate > 0 && (
                  <div className="flex  justify-between  bg-[#F6F6F6] mx-5 mt-3 p-2 rounded-2xl">
                    <div className="flex  flex-col  w-full gap-1">
                      <span className="text-[#BD6A01] text-sm sm:text-md  font-medium">
                        {t.meals.dinner}
                      </span>
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                        <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.5em"
                            height="1.5em"
                            viewBox="0 0 1024 1024"
                          >
                            <path
                              fill="currentColor"
                              d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                            />
                            <path
                              fill="currentColor"
                              d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                            />
                          </svg>
                          <span className="text-sm sm:text-md">
                            {getCategoryTime(
                              getCategoryRate("Dinner")?.categoryId
                            )
                              ?.header?.replace("Dinner (", "")
                              .replace(")", "")
                              .replace(/(am|pm)/g, " $1")
                              .replace("-", " - ")}
                          </span>
                        </span>
                        <div
                          className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[25%] bg-[#c66a10] text-white ${
                            mealshake.dinner && "shake"
                          }`}
                        >
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealDecrement("dinner");
                              e.stopPropagation();
                            }}
                          >
                            -
                          </button>
                          <span className="text-2xl font-bold mx-4">
                            {mealCounts?.dinner}
                          </span>
                          <button
                            className="text-2xl font-bold cursor-pointer"
                            onClick={(e) => {
                              handleMealIncrement("dinner");
                              e.stopPropagation();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </span>
                      <span className="text-[#BD6A01] font-medium flex -mt-3 ">
                        <span className="text-lg sm:text-xl">
                          ₹{getCategoryRate("Dinner")?.categoryRate}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
              {hasAnyMealAvailable && (
                <div className="flex  justify-between">
                  <span className="text-[#c66a10]  text-xs sm:text-sm font-medium px-5 pt-7">
                    {t.subTotal}
                  </span>
                  <span className="text-[#c66a10] text-2xl sm:text-3xl font-medium px-5 pt-7">
                    {subtotal === 0 ? <span>-</span> : <span>₹{subtotal}</span>}
                  </span>
                </div>
              )}
              {!hasAnyMealAvailable && (
                  <div className="flex items-center justify-center mt-4 mb-4 text-[#BD6A01] text-md sm:text-lg font-semibold">
                    {t.meals.no}
                  </div>
                )}
              <div className="flex  justify-center items-center">
                {isSecLoading && (
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                )}
                {hasAnyMealAvailable && (
                  <>
                    {!isSecLoading && (
                      <button
                        className={`drop-shadow-lg rounded-3xl w-[50%] sm:w-[45%] bg-[#c66a10] text-white py-2  ${
                          subtotal !== 0 || hasAnyMealQtySelected
                            ? "shadow-lg"
                            : "opacity-70"
                        }`}
                        onClick={
                          subtotal !== 0 || hasAnyMealQtySelected
                            ? PayOnlineMeals
                            : null
                        }
                      >
                        {t.payOnline}
                      </button>
                    )}
                  </>
                )}
              </div>
              <div className="flex  justify-center items-center">
                <span className="text-xs sm:text-sm font-medium px-7 py-3 opacity-70">
                  {t.Note}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* ashram tour popup */}
        {isThirdOpen && (
          <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center cursor-pointer"
            onClick={handleThirdClose}
          >
            <div
              className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 flex flex-col z-100 drop-shadow-lg  ${
                window.innerWidth >= 1300 && "w-[40%]"
              } ${
                window.innerWidth < 1300 &&
                window.innerWidth > 1000 &&
                "w-[60%]"
              } ${
                window.innerWidth < 1000 && "w-full"
              }  min-h-[50%] sm:min-h-[40%] max-h-[90%]  rounded-t-3xl bg-white cursor-default ${
                isThirdOpen ? "animate-slideIn" : "animate-slideOut"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
                <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5 ">
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  <h5 className="text-white px-4">{t.Ashram.tour}</h5>
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                </div>
              </div>
              {isTourLoading && (
                <div className="flex items-center justify-center mt-10">
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                </div>
              )}
              {!isTourLoading && TourList?.length > 0 && (
                <>
                  <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-7">
                    {t.AshramTourLine}
                  </span>
                  {TourList?.map((tour, index) => {
                    return (
                      <div
                        key={index}
                        className="flex  justify-between  bg-[#F6F6F6] mx-5 mt-3 p-2 rounded-2xl"
                      >
                        <div className="flex  flex-col  w-full gap-1">
                          <span className="text-[#BD6A01] text-sm sm:text-md  font-medium">
                            {tour?.name}
                          </span>
                          <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                            <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1.5em"
                                height="1.5em"
                                viewBox="0 0 1024 1024"
                              >
                                <path
                                  fill="currentColor"
                                  d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                                />
                                <path
                                  fill="currentColor"
                                  d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                                />
                              </svg>
                              <span className="text-sm sm:text-md">
                                {new Date(
                                  new Date(tour?.date_begin).getTime() +
                                    5.5 * 60 * 60 * 1000
                                )
                                  .toLocaleString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace("AM", "a.m.")
                                  .replace("PM", "p.m.")}{" "}
                                &nbsp;to&nbsp;
                                {new Date(
                                  new Date(tour?.date_end).getTime() +
                                    5.5 * 60 * 60 * 1000
                                )
                                  .toLocaleString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace("AM", "a.m.")
                                  .replace("PM", "p.m.")}
                              </span>
                            </span>
                          </span>
                          <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                            <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1.5em"
                                height="1.5em"
                                viewBox="0 0 1024 1024"
                              >
                                <path
                                  fill="currentColor"
                                  d="M512 64C308.8 64 144 228.8 144 432c0 123.2 81.6 231.2 162.4 325.6c75.2 88 151.2 167.2 165.6 181.6c15.2 15.2 40 15.2 55.2 0c14.4-14.4 90.4-93.6 165.6-181.6C798.4 663.2 880 555.2 880 432C880 228.8 715.2 64 512 64zM512 560c-70.4 0-128-57.6-128-128s57.6-128 128-128s128 57.6 128 128s-57.6 128-128 128z"
                                />
                              </svg>
                              <span className="text-sm sm:text-md">
                                {tour?.address_id && tour?.address_id[1]}
                              </span>
                            </span>
                          </span>
                        </div>
                        <div
                          className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[29%] bg-[#c66a10] text-white cursor-pointer m-4`}
                          onClick={() => {
                            BookPopupHandle(tour);
                          }}
                        >
                          <h5 className="font-bold mx-4">{t.BookButton}</h5>
                        </div>
                      </div>
                    );
                  })}
                  <div className="flex  justify-center items-center">
                    <span className="text-xs sm:text-sm font-medium px-7 py-3 opacity-70">
                      {t.AshramTourLineNote}
                    </span>
                  </div>
                </>
              )}
              {!isTourLoading && TourList?.length === 0 && (
                <>
                  <div className="flex  justify-center items-center mt-10">
                    <span className="text-xs sm:text-sm font-medium px-7 py-3 opacity-70">
                      No Tour Available
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {/* {TourPopup && (
          <div
            className="fixed top-0 left-0 w-full h-[100vh] bg-black bg-opacity-50 flex justify-center items-center cursor-pointer z-100"
            onClick={handlePopupClose}
          >
            <div
              className={`w-full h-full flex flex-col justify-center items-center`}
            >
              <div
                className={`${window.innerWidth >= 1300 && "w-[40%]"} ${
                  window.innerWidth < 1300 &&
                  window.innerWidth > 1000 &&
                  "w-[60%]"
                } ${
                  window.innerWidth < 1000 && "w-full"
                }  min-h-[35%] sm:min-h-[40%] max-h-[90%] bg-white rounded-3xl drop-shadow-lg flex flex-col items-center`}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className={`absolute -top-10 left-1/2 transform -translate-x-1/2 flex flex-col justify-center items-center z-100 drop-shadow-lg `}
                >
                  <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5">
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                    <h5 className="text-white px-4">{t.Ashram.tour}</h5>
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  </div>
                </div>

                <div className="w-[50%] h-max	 flex justify-center bg-[#F6F6F6] mx-5 mt-7 p-2 rounded-2xl">
                  <div className="flex flex-col w-full gap-1">
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-center">
                      {TourPopup?.name}
                    </span>
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-center w-full">
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                        <svg
                          xmlns="(link unavailable)"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            fill="currentColor"
                            d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                          />
                          <path
                            fill="currentColor"
                            d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                          />
                        </svg>
                        <span className="text-sm sm:text-md">
                          {new Date(
                            new Date(TourPopup?.date_begin).getTime() +
                              5.5 * 60 * 60 * 1000
                          )
                            .toLocaleString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace("AM", "a.m.")
                            .replace("PM", "p.m.")}{" "}
                          &nbsp;to&nbsp;
                          {new Date(
                            new Date(TourPopup?.date_end).getTime() +
                              5.5 * 60 * 60 * 1000
                          )
                            .toLocaleString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace("AM", "a.m.")
                            .replace("PM", "p.m.")}
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-4">
                  {t.BookHeadingFirst}
                </span>
                <span className="text-[#c66a10] text-sm sm:text-lg font-medium ">
                  {t.BookHeadingSec(TourPopup?.address_id && TourPopup?.address_id[1])}
                </span>
                <div className="flex justify-evenly w-full px-5 pt-4 pb-4">
                  <div
                    className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[29%] bg-[#c66a10] text-white cursor-pointer p-2`}
                    onClick={() => {
                      BookPopupSecHandle(TourPopup);
                    }}
                  >
                    <h5 className="font-bold mx-4">{t.ProceedButton}</h5>
                  </div>
                  <div
                    className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[29%] text-[#c66a10] bg-white cursor-pointer border-2 border-[#c66a10]`}
                    onClick={handlePopupClose}
                  >
                    <h5 className="font-bold mx-4">{t.BackButton}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}
        {TourSecPopup && (
          <div
            className="fixed top-0 left-0 w-full h-[100vh] bg-black bg-opacity-50 flex justify-center items-center cursor-pointer z-100"
            onClick={handlePopupSecClose}
          >
            <div
              className={`w-full h-full flex flex-col justify-center items-center`}
            >
              <div
                className={`${window.innerWidth >= 1300 && "w-[40%]"} ${
                  window.innerWidth < 1300 &&
                  window.innerWidth > 1000 &&
                  "w-[60%]"
                } ${
                  window.innerWidth < 1000 && "w-full"
                }  min-h-[35%] sm:min-h-[40%] max-h-[90%] bg-white rounded-3xl drop-shadow-lg flex flex-col `}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className={`absolute -top-10 left-1/2 transform -translate-x-1/2 flex flex-col  z-100 drop-shadow-lg `}
                >
                  <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5">
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                    <h5 className="text-white px-4">{t.Ashram.tour}</h5>
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  </div>
                </div>
                <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-7">
                  {t.CountLine}
                </span>
                <div className="flex  justify-between  bg-[#F6F6F6] mx-5 mt-3 p-2 rounded-2xl">
                  <div className="flex  flex-col  w-full gap-1">
                    <span className="text-[#BD6A01] text-sm sm:text-md  font-medium">
                      {TourSecPopup?.name}
                    </span>
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            fill="currentColor"
                            d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                          />
                          <path
                            fill="currentColor"
                            d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                          />
                        </svg>
                        <span className="text-sm sm:text-md">
                          {new Date(
                            new Date(TourSecPopup?.date_begin).getTime() +
                              5.5 * 60 * 60 * 1000
                          )
                            .toLocaleString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace("AM", "a.m.")
                            .replace("PM", "p.m.")}{" "}
                          &nbsp;to&nbsp;
                          {new Date(
                            new Date(TourSecPopup?.date_end).getTime() +
                              5.5 * 60 * 60 * 1000
                          )
                            .toLocaleString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace("AM", "a.m.")
                            .replace("PM", "p.m.")}
                        </span>
                      </span>
                    </span>
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            fill="currentColor"
                            d="M512 64C308.8 64 144 228.8 144 432c0 123.2 81.6 231.2 162.4 325.6c75.2 88 151.2 167.2 165.6 181.6c15.2 15.2 40 15.2 55.2 0c14.4-14.4 90.4-93.6 165.6-181.6C798.4 663.2 880 555.2 880 432C880 228.8 715.2 64 512 64zM512 560c-70.4 0-128-57.6-128-128s57.6-128 128-128s128 57.6 128 128s-57.6 128-128 128z"
                          />
                        </svg>
                        <span className="text-sm sm:text-md">
                          {TourSecPopup?.address_id &&
                            TourSecPopup?.address_id[1]}
                        </span>
                      </span>
                    </span>
                  </div>
                  <div
                    className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[40%] sm:w-[25%] bg-[#c66a10] px-4 text-white m-3 ${
                      BookCountShake && "shake"
                    }`}
                  >
                    <button
                      className="text-2xl font-bold cursor-pointer"
                      onClick={(e) => {
                        if (BookCounts > 0) {
                          setBookCounts(Math.max(BookCounts - 1, 0));
                        } else {
                          setBookCountShake(true);
                          setTimeout(() => {
                            setBookCountShake(false);
                          }, [200]);
                        }
                        e.stopPropagation();
                      }}
                    >
                      -
                    </button>
                    <span className="text-2xl font-bold mx-4">
                      {BookCounts}
                    </span>
                    <button
                      className="text-2xl font-bold cursor-pointer"
                      onClick={(e) => {
                        if (BookCounts < MaxBookCounts) {
                          setBookCounts(BookCounts + 1);
                        } else {
                          setBookCountShake(true);
                          setTimeout(() => {
                            setBookCountShake(false);
                          }, [200]);
                        }
                        e.stopPropagation();
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="flex  justify-center items-center pt-3">
                  {isTourSubmitLoading && (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  )}
                  <>
                    {!isTourSubmitLoading && (
                      <button
                        className={`drop-shadow-lg rounded-3xl w-[50%] sm:w-[45%] bg-[#c66a10] text-white py-2  ${
                          BookCounts > 0 ? "shadow-lg" : "opacity-70"
                        }`}
                        onClick={BookCounts > 0 ? OnlineBook : null}
                      >
                        {t.BookButton}
                      </button>
                    )}
                  </>
                </div>
                <div className="flex  justify-center items-center">
                  <span className="text-xs sm:text-sm font-medium px-7 py-3 opacity-70">
                    {t.AshramTourLineNote}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {CancelTourSecPopup && (
          <div
            className="fixed top-0 left-0 w-full h-[100vh] bg-black bg-opacity-50 flex justify-center items-center cursor-pointer z-100"
            onClick={handleCancelClose}
          >
            <div
              className={`w-full h-full flex flex-col justify-center items-center`}
            >
              <div
                className={`${window.innerWidth >= 1300 && "w-[40%]"} ${
                  window.innerWidth < 1300 &&
                  window.innerWidth > 1000 &&
                  "w-[60%]"
                } ${
                  window.innerWidth < 1000 && "w-full"
                }  min-h-[35%] sm:min-h-[40%] max-h-[90%] bg-white rounded-3xl drop-shadow-lg flex flex-col items-center`}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className={`absolute -top-10 left-1/2 transform -translate-x-1/2 flex flex-col justify-center items-center z-100 drop-shadow-lg `}
                >
                  <div className="flex items-center justify-between bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5">
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                    <h5 className="text-white px-4">{t.Ashram.cancel}</h5>
                    <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                  </div>
                </div>
                <div className="w-[50%] h-max	 flex justify-center bg-[#F6F6F6] mx-5 mt-7 p-2 rounded-2xl">
                  <div className="flex flex-col w-full gap-1">
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-center">
                      {CancelTourSecPopup?.name}
                    </span>
                    <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-center w-full">
                      <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex gap-2">
                        <svg
                          xmlns="(link unavailable)"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            fill="currentColor"
                            d="M512 896a384 384 0 1 0 0-768a384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896a448 448 0 0 1 0 896"
                          />
                          <path
                            fill="currentColor"
                            d="M672 234.88c-39.168 174.464-80 298.624-122.688 372.48c-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                          />
                        </svg>
                        <span className="text-sm sm:text-md">
                          {TourHistoryListById[CancelTourSecPopup?.name] &&
                            TourHistoryListById[
                              CancelTourSecPopup?.name
                            ]?.[0] && (
                              <div>
                                {new Date(
                                  new Date(
                                    TourHistoryListById[
                                      CancelTourSecPopup?.name
                                    ][0]?.date_begin
                                  ).getTime() +
                                    5.5 * 60 * 60 * 1000
                                )
                                  .toLocaleString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace("AM", "a.m.")
                                  .replace("PM", "p.m.")}{" "}
                                -
                                {new Date(
                                  new Date(
                                    TourHistoryListById[
                                      CancelTourSecPopup?.name
                                    ][0]?.date_end
                                  ).getTime() +
                                    5.5 * 60 * 60 * 1000
                                )
                                  .toLocaleString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace("AM", "a.m.")
                                  .replace("PM", "p.m.")}
                              </div>
                            )}
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                <span className="text-[#c66a10] text-sm sm:text-lg font-medium px-5 pt-4">
                  {t.Ashram.cancelPopup}
                </span>
                <span className="text-[#c66a10] text-sm sm:text-lg font-medium ">
                  {t.Ashram.cancelPopupTwo}
                </span>
                <div className="flex justify-evenly w-full px-5 pt-4 pb-4">
                  {isCancelLoading === CancelTourSecPopup?.id && (
                    <svg
                      aria-hidden="true"
                      class="w-7 h-7 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  )}
                  {isCancelLoading !== CancelTourSecPopup?.id && (
                    <div
                      className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[29%] bg-[#c66a10] text-white cursor-pointer p-2`}
                      onClick={() => {
                        CancelBook(CancelTourSecPopup?.id);
                      }}
                    >
                      <h5 className="font-bold mx-4">{t.Ashram.cancelBtn}</h5>
                    </div>
                  )}
                  {isCancelLoading !== CancelTourSecPopup?.id && (
                    <div
                      className={`flex flex-row justify-evenly items-center drop-shadow-lg rounded-3xl w-[35%] sm:w-[29%] text-[#c66a10] bg-white cursor-pointer border-2 border-[#c66a10]`}
                      onClick={handleCancelClose}
                    >
                      <h5 className="font-bold mx-4">{t.BackButton}</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedImage && (
          <div
            className="fixed top-0 left-0 w-full h-[100vh] bg-black bg-opacity-50 flex justify-center items-center cursor-pointer z-100"
            onClick={() => {
              setSelectedImage(null);
            }}
          >
            <div
              className={`w-full h-full flex flex-col justify-center items-center`}
            >
              <div
                className={`${window.innerWidth >= 1300 && "w-[40%]"} ${
                  window.innerWidth < 1300 &&
                  window.innerWidth > 1000 &&
                  "w-[60%]"
                } ${
                  window.innerWidth < 1000 && "w-[80%]"
                }  min-h-[30%] sm:min-h-[40%] max-h-[90%] bg-transparent rounded-3xl drop-shadow-lg flex flex-col items-center`}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <img
                  src={selectedImage}
                  alt="Scanner"
                  className="w-8/12 h-8/12 object-fit object-center"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
};
export default DashBoard;
